import { connect } from 'react-redux'
import SchoolHeadTitle from './school-head-title'
import { withMe } from 'pobble-components/dist/pobble-user'
import { getSchool } from '../../../stores/me/me.selectors'

const mapStateToProps = (state, { me }) => ({
  title: getSchool(me).title
})

export default withMe(
  connect(
    mapStateToProps,
    null
  )(SchoolHeadTitle)
)
